import 'whatwg-fetch'

export default class FormRuleApiService {

  constructor(rails_authenticity_token){
    this.rails_authenticity_token = rails_authenticity_token;
  }

  getFormRule(form_rule_id, keenform_id){
    return window.fetch(`/dashboard/keenforms/${keenform_id}/form_rules/${form_rule_id}.json`, {
      method: 'GET'
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(form_rule) {
      return form_rule;
    })
    .catch(function(error) {
      console.log(error);
    });
  }

  reorderFormRules(keenform_id, form_rules){
    const updatedFormRuleObj = {};
    form_rules.forEach( (fr, index) => {
      updatedFormRuleObj[index.toString()] = {
        id: fr.id,
        position: fr.position,
        keenform_id: keenform_id
      }
    })
    const params = {
      authenticity_token: this.rails_authenticity_token,
      keenform: {
        form_rules_attributes: updatedFormRuleObj
      }
    };
    const updateKeenformUrl = `/dashboard/keenforms/${keenform_id}`;
    return window.fetch(updateKeenformUrl, {
      method: 'PUT',
      body: JSON.stringify(params),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(response) {
      return response;
    })
    .catch( (error) => {
      console.log('error occurred in api service', error);
    })
  }

  deleteFormRule(form_rule_id, keenformId) {
    let params = {
      authenticity_token: this.rails_authenticity_token,
    };
    return window.fetch(`/dashboard/keenforms/${keenformId}/form_rules/${form_rule_id}.json`, {
      method: 'DELETE',
      body: JSON.stringify(params),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then( (response) => {
      //TODO: check response.ok to determine what happened, handle differently for error
      return response.json();
    })
    .then((response) => {
      console.log('Form rule has been deleted, reload the page');
      return response;
    })
    .catch(function(error) {
      console.log('deleting form rule failed: ', error);
      return error;
    });
  }

}